import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const ChevronRightIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M9.0001 16.702L13.2241 12.5L9.00009 8.298L10.2981 7L15.7981 12.5L10.2981 18L9.0001 16.702Z'
                fill='currentColor'
            />
        </>
    ),
})

ChevronRightIcon.displayName = 'ChevronRightIcon'
